export default class DureeContratDto {
  id;
  duree;
  nbEffectif;
}
